import Clarity from '@microsoft/clarity';

// Configuration object for Clarity
const clarityConfig = {
  // Add any additional configuration options here
  // For example: userId, sessionId, etc.
};

/**
 * Initialize Microsoft Clarity
 * @param {string} projectId - Your Clarity project ID
 */
export const initClarity = (projectId) => {
  if (!projectId) {
    console.warn('Clarity: Project ID is required');
    return;
  }

  // Only initialize in production or when explicitly enabled
  if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_CLARITY === 'true') {
    try {
      Clarity.init(projectId);
      console.log('Clarity initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Clarity:', error);
    }
  } else {
    console.log('Clarity: Skipping initialization in development mode');
  }
};

/**
 * Identify a user in Clarity
 * @param {string} customId - User identifier (required)
 * @param {string} customSessionId - Custom session ID (optional)
 * @param {string} customPageId - Custom page ID (optional) 
 * @param {string} friendlyName - Friendly name (optional)
 */
export const identifyUser = (customId, customSessionId = null, customPageId = null, friendlyName = null) => {
  try {
    Clarity.identify(customId, customSessionId, customPageId, friendlyName);
  } catch (error) {
    console.error('Clarity identify error:', error);
  }
};

/**
 * Set a custom tag for the session
 * @param {string} key - Tag key
 * @param {string|string[]} value - Tag value(s)
 */
export const setTag = (key, value) => {
  try {
    Clarity.setTag(key, value);
  } catch (error) {
    console.error('Clarity setTag error:', error);
  }
};

/**
 * Track a custom event
 * @param {string} eventName - Name of the event
 */
export const trackEvent = (eventName) => {
  try {
    Clarity.event(eventName);
  } catch (error) {
    console.error('Clarity event error:', error);
  }
};

/**
 * Give consent for Clarity tracking
 * @param {boolean} consent - Whether consent is given (default: true)
 */
export const giveConsent = (consent = true) => {
  try {
    Clarity.consent(consent);
  } catch (error) {
    console.error('Clarity consent error:', error);
  }
};

/**
 * Upgrade the current session
 * @param {string} reason - Reason for upgrading
 */
export const upgradeSession = (reason) => {
  try {
    Clarity.upgrade(reason);
  } catch (error) {
    console.error('Clarity upgrade error:', error);
  }
};

export default {
  initClarity,
  identifyUser,
  setTag,
  trackEvent,
  giveConsent,
  upgradeSession
}; 